import { ListItemText, listItemTextClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import Colors from '../../../../../ui/layout/theme/utils/colors';

export const StyledMenuListItemText = styled(ListItemText)(({ theme }) => ({
  [`& .${listItemTextClasses.primary}`]: {
    fontFamily: 'Sora',
    fontSize: '14px',
    color: Colors.dark_jungle_green,
  },
}));
